import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { popupSteps } from "../../../constants/orderTariffFormPopup";
import { TARIFF_TYPES, USER_TYPES } from "../../../constants/types";
import { getPageSettings, getUserType } from "./shared";

/*
 * TODO: В рамках задачи FIRST-1329 переименовать селекторы get => select
 * */

export var getOrderTariffData = function getOrderTariffData(state) {
  return state.orderTariffPopup || emptyObj;
};
export var getOrderTariffCommonData = function getOrderTariffCommonData(state) {
  return getOrderTariffData(state).orderProgress || emptyObj;
};
export var getTariffDetailsFromStore = function getTariffDetailsFromStore(state) {
  return getOrderTariffData(state).tariffServices || emptyObj;
};

// wrapper selectors
export var getCurrentFormStep = function getCurrentFormStep(state) {
  return getOrderTariffCommonData(state).currentStep;
};
export var selectCommonData = function selectCommonData(state) {
  return getOrderTariffCommonData(state).popupData || emptyObj;
};
var getFullFromFlag = function getFullFromFlag(state) {
  return getOrderTariffCommonData(state).showFullForm;
};
export var getUniConstructorRedirectFlag = function getUniConstructorRedirectFlag(state) {
  return getOrderTariffCommonData(state).uniConstructorRedirectFlag;
};
export var getAddressView = function getAddressView(state) {
  return getOrderTariffCommonData(state).addressView;
};
export var getCaptchaFlag = function getCaptchaFlag(state) {
  return selectCommonData(state).showCaptcha || false;
};
export var getIsOpenPopupFlag = function getIsOpenPopupFlag(state) {
  return getOrderTariffCommonData(state).isOpen;
};

// селекторы для текстов
export var getOrderTariffTexts = function getOrderTariffTexts(state) {
  return selectCommonData(state).texts.fullFormPopupTexts || emptyObj;
};
export var getAddressRequestTexts = function getAddressRequestTexts(state) {
  return getOrderTariffTexts(state).addressRequestTexts || emptyObj;
};
export var getAddressNotAvailableTexts = function getAddressNotAvailableTexts(state) {
  return getOrderTariffTexts(state).notAvailableTexts || emptyObj;
};

// селекторы для получения тарифа
export var getAlternativeTariffType = function getAlternativeTariffType(state) {
  return getOrderTariffCommonData(state).alternativeTariffType || emptyObj;
};
export var getTargetTariffType = function getTargetTariffType(state) {
  return getOrderTariffCommonData(state).tariffType || emptyObj;
};
export var getMobileTariffsAliases = function getMobileTariffsAliases(state) {
  return getOrderTariffCommonData(state).mobileTariffsAliases || emptyArr;
};
export var getTariffType = function getTariffType(state) {
  var currentStep = getCurrentFormStep(state);
  return currentStep === popupSteps.alternativeTariff ? getAlternativeTariffType(state) : getTargetTariffType(state);
};
export var selectIsFttbTariffType = createSelector([getTariffType], function (_ref) {
  var tariffType = _ref.tariffType;
  return [TARIFF_TYPES.internet, TARIFF_TYPES.kit].includes(tariffType);
});
export var getIsShowFullFormPopup = createSelector([getFullFromFlag, getTariffType, getPageSettings, getUserType], function (showFullForm, _ref2, _ref3, userType) {
  var tariffType = _ref2.tariffType,
    isTariffCallbackFlag = _ref2.isTariffCallbackFlag;
  var isAuth = _ref3.isAuth;
  /** при наличии у карточки тарифа признака isTariffCallbackFlag - показывать форму заказа обратного звонка */
  if (isTariffCallbackFlag) {
    return false;
  }
  if (userType === USER_TYPES.FTTB_USER) {
    return false;
  }
  var isAllowedTariffTypes = [TARIFF_TYPES.internet, TARIFF_TYPES.kit, TARIFF_TYPES.presetUp].includes(tariffType);
  return !isAuth && showFullForm && isAllowedTariffTypes;
});
export var getIsPresetUpFlag = function getIsPresetUpFlag(state) {
  return getTargetTariffType(state).tariffType === TARIFF_TYPES.presetUp;
};